// extracted by mini-css-extract-plugin
export default {"product-container":"ProductsList_product-container__im3pu"};